webpackJsonp([0],{

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  asyncData: function asyncData(_ref) {
    var store = _ref.store;

    return store.dispatch('home/getHome');
  },

  name: 'dashboard',
  // created () {
  //   return this.$store.dispatch('home/getHome')
  // },
  data: function data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + ' swiper-pagination-bullet-custom">&nbsp;</span>';
          }
        }
      },
      bottomSwiperOption: {
        autoplay: false,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + ' swiper-pagination-bullet-custom">&nbsp;</span>';
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('home', ['home'])),
  methods: {
    onSlideChange: function onSlideChange(e) {
      var swiper = this.$refs.topBanner.swiper;
      var index = swiper.realIndex;
      if (index === swiper.slides.length - 1) {
        setTimeout(function () {
          swiper.slideTo(0);
        }, 8000);
      }
    }
  }
});

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(217)("4349f8a2", content, true, {});

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(216)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Dashboard.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid container fc-dashboard"},[_c('div',{staticClass:"fc-top-banner"},[_c('swiper',{ref:"topBanner",attrs:{"options":_vm.swiperOption},on:{"slideChange":_vm.onSlideChange}},[_vm._l((_vm.home.TopBanners),function(banner){return (_vm.home.TopBanners.length > 0)?_c('swiper-slide',{key:banner.BannerId,style:({'background-color': banner.BgColor})},[_c('a',{attrs:{"href":banner.Url}},[_c('img',{attrs:{"src":banner.PhotoKey}}),_vm._v(" "),_c('div',{staticClass:"ui container"},[_c('div',[_vm._v("\n              "+_vm._s(banner.Title)+"\n            ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(banner.Body))]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":banner.Url}},[_vm._v("START ORDER")])])])])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination swiper-pagination-bullets",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ui fluid container fc-catering"},[_c('swiper',{attrs:{"options":_vm.bottomSwiperOption}},[_vm._l((_vm.home.BottomBanners),function(banner){return _c('swiper-slide',{key:banner.BannerId,style:({'background-color': banner.BgColor})},[_c('a',{attrs:{"href":banner.Url}},[_c('img',{attrs:{"src":banner.PhotoKey}}),_vm._v(" "),_c('div',{staticClass:"fc-cover"}),_vm._v(" "),_c('div',{staticClass:"ui container"},[_c('div',[_vm._v("\n              "+_vm._s(banner.Title)+"\n            ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(banner.Body))]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":banner.Url}},[_vm._v("START ORDER")])])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination swiper-pagination-bullets",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1),_vm._v(" "),_c('div',{staticClass:"ui fluid container fc-locations"},[_c('div',{staticClass:"ui container"},[_vm._m(1),_vm._v(" "),_c('div',[_c('p',[_vm._v("OUR LOCATION")]),_vm._v(" "),_vm._l((_vm.home.OurLocation),function(outlet){return _c('div',[_c('span',[_vm._v(_vm._s(outlet.Name))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(outlet.Address)}}),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(outlet.Country)+" "+_vm._s(outlet.PostalCode)+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"fc-tel"},[_vm._v("+"+_vm._s(outlet.PhoneNumber))]),_vm._v(" "),_c('span',[_vm._v("Operation Hours:")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(outlet.OperatingHours)}})])})],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container fc-category-list"},[_c('div',[_c('div',[_c('a',{attrs:{"href":"combo-package"}},[_c('img',{attrs:{"src":__webpack_require__(406)}}),_vm._v(" "),_c('span',[_vm._v("Quick Order")])])])]),_vm._v(" "),_c('div',[_c('div',[_c('a',{attrs:{"href":"sandwiches"}},[_c('img',{attrs:{"src":__webpack_require__(407)}}),_vm._v(" "),_c('span',[_vm._v("Sandwiches")])])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"sub-platters"}},[_c('img',{attrs:{"src":__webpack_require__(408)}}),_vm._v(" "),_c('span',[_vm._v("Party Platters")])])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(409)}})])])]),_vm._v(" "),_c('div',[_c('div',[_c('a',{attrs:{"href":"drinks"}},[_c('img',{attrs:{"src":__webpack_require__(410)}}),_vm._v(" "),_c('span',[_vm._v("Drinks")])])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"snacks-desserts"}},[_c('img',{attrs:{"src":__webpack_require__(411)}}),_vm._v(" "),_c('span',[_vm._v("Snacks/Desserts")])])]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"giant-sub"}},[_c('img',{attrs:{"src":__webpack_require__(412)}}),_vm._v(" "),_c('span',[_vm._v("Giant Sub")])])])]),_vm._v(" "),_c('div',[_c('div',[_c('a',{attrs:{"href":"lunch-boxes"}},[_c('img',{attrs:{"src":__webpack_require__(413)}}),_vm._v(" "),_c('span',[_vm._v("Lunch Boxes")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__(414)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2d7f45e29226d65dc7cb346b758a7fe.png";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e4d04a8f7203f097fc6c527ce86bcbc8.png";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f0a6f429d069e70c6d626089d1c089f.png";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "66e1972196c6d844b2f1cc33cabe4424.png";

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ebf2ff7508d98dd39230152525ef24a.png";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "262970974c843445bf353cd26fe3efa1.png";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee43f73a17edeb06898d85245eea80c1.png";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9dd66f3c3e9239d8005b5b6523eca88c.png";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48d87cb7b60e63b773646038cf4e2500.png";

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(248);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abfca2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(405);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1abfca2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1abfca2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.js?v=1698631571653